<template>
    <div class="">
      <v-dialog
        class="popbox"
        name="dialog2"
        v-model="isShow"
        :title="updataOrview == 1 ? '修改参数' : '查看参数'"
        close-on-click-modal
        :modal="true"
        :width="668"
        @open="open"
        @after-close="handleAfterClose"
        @confirm="handleConfirm"
        :showConfirm="updataOrview == 1 ? true : false"
        append-to-body
      >
        <v-form ref="form" :model="ruleForm" :rules="rules">

          <v-form-item  prop="name" >
            <template slot="label">
              <span class="required">*</span>
              <span>字段名称</span>
            </template>
            <v-input type="text" :disabled="updataOrview == 2" name="name" v-model="ruleForm.name"></v-input>
          </v-form-item>

          <v-form-item  prop="identifier" >
            <template slot="label">
              <span class="required">*</span>
              <span>字段标识</span>
            </template>
            <v-input type="text" :disabled="updataOrview == 2" name="identifier" v-model="ruleForm.identifier"></v-input>
          </v-form-item>
          <v-form-item  prop="data_type" >
            <template slot="label">
              <span class="required">*</span>
              <span>数据类型</span>
            </template>
            <!-- <v-input type="text" name="data_type" v-model="ruleForm.data_type"></v-input> -->
            <v-select id="data_type" :disabled="updataOrview == 2" name="data_type" v-model="ruleForm.data_type" :options="dataTypeOptins"></v-select>
          </v-form-item>
          <v-form-item  prop="mark" :required="false" >
            <template slot="label">
              <span>备注</span>
            </template>
            <v-input type="textarea" :maxlength="254" class="Description" show-word-limit name="mark" v-model="ruleForm.mark"></v-input>
          </v-form-item>

          <!-- <v-form-item prop="unit"  :required="false">
            <template slot="label">
              <span class="required"></span>
              <span>单位</span>
            </template>
            <v-input type="text" :disabled="updataOrview == 2" name="unit" v-model="ruleForm.unit"></v-input>
          </v-form-item> -->

        </v-form>
        <v-loading class="loading-box"  :visible="!upTips" name="loading4"></v-loading>

      </v-dialog>

    </div>

</template>

<script>
import { copy } from '@/common/libs/utils';
  export default {
    components: {},
    props:{
    showInputDialog:{
      type:Boolean,
      default: false
    },
    updateIndex:{},
    updataOrview:{},
    ParamData:[],
    propData:{
    type:Object,
    default: ()=>{}
  }
  },
    data() {
      return {
        rules: {
          name: copy([{
            type: "fieldNameInput"
          }]),
          identifier: copy([{
            type: "identifier"
          }]),
        },
        ruleForm:{
          name: "",
          identifier: "",
          data_type: '',
          mark: ""
          // unit: ''
        },
        dataTypeOptins:[
          {
              label: "int(整数)",
              value: 'int'
          },
          {
              label: "float64(浮点数)",
              value: 'float64'
          },
          {
              label: "string(字符串)",
              value: 'string'
          },
          {
              label: "bool(布尔值)",
              value: 'bool'
          },
          {
              label: "array(数组)",
              value: 'array'
          },
          {
              label: "struct(结构)",
              value: 'struct'
          }
        ],
        dialogTitle: "修改参数",

        isShow:false,
        nameRepeat: false,
        identifierRepeat: false,
        upTips:true,
      };
    },
    watch:{
      showInputDialog(newVal){
        this.isShow = newVal
      }
    },
    methods: {
      open(){
        this.ruleForm = copy(this.propData)
      },
      handleConfirm() {
        const valid = this.$refs.form.submitForm();
        if (valid === false) {
          return;
        }
        this.nameRepeat = false
        this.identifierRepeat = false
        this.ParamData?.map((item, index) => {
          if (this.updateIndex != index && item.name == this.ruleForm.name) {
            this.nameRepeat = true
          }
          if (this.updateIndex != index && item.identifier == this.ruleForm.identifier) {
            this.identifierRepeat = true
          }
        })
        if (this.nameRepeat == true) {
          this.$message.error(("参数名称已添加不能重复"))
          return
        }
        if (this.identifierRepeat == true) {
          this.$message.error(("标识符已添加不能重复"))
          return
        }

        this.$emit('updatainputDataList', this.ruleForm, this.updateIndex)
        this.$emit('update:showInputDialog',false)
      },
      handleAfterClose() {
        this.$emit('update:showInputDialog',false)
      }
    },
    beforeDestroy() {},
  };
  </script>

  <style lang="scss">
  </style>
